import classNames from "classnames";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";
import styles from "./css/Button.module.css";
import Spinner from "./Spinner";

export type ButtonVariant =
  "primary" | "secondary" | "outline" | "ghost" | "danger" | "inverted";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  loading?: boolean;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = "primary",
    size = "md",
    fullWidth = false,
    loading = false,
    leadingIcon,
    trailingIcon,
    disabled,
    className,
    children,
    type = "button",
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={classNames(
        styles.button,
        styles[variant],
        styles[size],
        { [styles.fullWidth]: fullWidth, [styles.loading]: loading },
        className
      )}
      {...rest}
    >
      {loading && (
        <span className={styles.spinner}>
          <Spinner size={size === "sm" ? 14 : 18} />
        </span>
      )}
      {leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
      {children !== undefined && (
        <span className={styles.label}>{children}</span>
      )}
      {trailingIcon && <span className={styles.icon}>{trailingIcon}</span>}
    </button>
  );
});

export default Button;
